<div class="form-group">
    <div class="row fields-group">

        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate_validation' | translate }}</label>
        </div>
        <div class="col">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input"
                   name="booleanValue" id="booleanValueTrue" required
                   [checked]="trueValueChecked === 1"
                   (change)="booleanValueChanged(true)">
                <label class="custom-control-label" for="booleanValueTrue">{{'dets.is_valid' | translate}}</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input"
                   name="booleanValue" id="booleanValueFalse" required
                   [checked]="trueValueChecked === 0"
				   (change)="booleanValueChanged(false)">
                <label class="custom-control-label" for="booleanValueFalse">{{'dets.is_invalid' | translate}}</label>
            </div>
        </div>
    </div>
</div>